export enum StatusType {
  CONNECT = 'CONNECT',
  DISCONNECT = 'DISCONNECT',
  UNKNOWN = 'UNKNOWN',
}

export interface StatusEvent {
  serialNumber: string;
  type: StatusType;
  timestamp: number;
}
